import { WithName } from '@schooly/api';

function getFirstName(user: WithName, forceGivenName?: boolean): string {
  if (!forceGivenName && user.known_as) return user.known_as;
  return user.given_name ?? '';
}

/**
 * @deprecated Import from `@schooly/utils/user-helpers` instead.
 */
export function getUserFullName(user: WithName, forceGivenName?: boolean) {
  if (!user) return '';
  const first = getFirstName(user, forceGivenName);
  return user.last_name ? `${first} ${user.last_name}` : first;
}

/**
 * @deprecated Use `getUserInitials` from `@schooly/utils/user-helpers` instead.
 */
export const getInitials = (name: string) =>
  name
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('');
